import request from './request'
import { getStockQuotes } from './stockQuotes'
import { quoteNumber } from './quoteDisplay'
import { stockSelection } from '@/views/stock/stockSelection'
import { marketRequest } from './marketRefresh'
import { parseTrades } from '@/views/market/hongKongTrade'

export async function workspaceQuote(code, normalize, initial = false) {
  if (initial) {
    const result = await request({ url: 'vexe/v1/stock/baseData', method: 'get', params: { code } })
    const value = result && result.stock && result.stock[0]
    if (!value || !(quoteNumber(value.price) > 0)) throw new Error('首载行情不可用')
    const foreign = /^(hk|us)/i.test(code) || /\.(hk|us|usa)$/i.test(code)
    return { name: value.name, price: value.price, change: value.increase, high: value.high, low: value.low, open: value.open, close: value.yclose, turnover: value.exchangerate, amplitude: value.amplitude, volume: value.vol, amount: value.amount, marketValue: value.marketvalue, floatValue: value.flowmarketvalue, pe: foreign ? value.pe : value.pe2 == null ? value.pe : value.pe2, pb: value.pb }
  }
  const key = /^(\d{6})\.(sh|sz|bj)$/i.test(code) ? code.slice(-2).toLowerCase() + code.slice(0, -3) : code
  const values = await getStockQuotes(key)
  const value = normalize(values[key])
  if (!(quoteNumber(value.price) > 0)) throw new Error('行情不可用')
  return value
}

export async function workspaceTrades(code, initial = false) {
  if (initial) {
    const value = await request({ url: 'vexe/v1/stock/mingXi', method: 'get', params: { code } })
    const rows = value && value.stock && value.stock[0] && value.stock[0].deal
    if (!Array.isArray(rows)) throw new Error('分时成交首载失败')
    return rows.map((row, index) => ({
      id: `${row.time}-${index}`,
      time: String(row.time).replace(/^(\d{2})(\d{2})(\d{2})?$/, (_, hour, minute, second) => `${hour}:${minute}${second ? ':' + second : ''}`),
      price: row.price, volume: row.vol, direction: Number(row.bs) === 0 ? 'B' : /^us/i.test(code) || Number(row.bs) === 1 ? 'S' : 'M'
    })).filter(row => row.time && quoteNumber(row.price) > 0)
  }
  const symbol = /^(\d{6})\.(sh|sz|bj)$/i.test(code) ? code.slice(-2).toLowerCase() + code.slice(0, -3) : code
  const cn = /^(sh|sz|bj)\d{6}$/i.test(symbol)
  const result = await marketRequest(cn ? 'cn-trades' : /^us/i.test(symbol) ? 'us-trades' : 'trades', { code: symbol })
  const rows = result && result.data && (cn ? result.data.data : result.data.details)
  if (!result || result.code !== 0 || !Array.isArray(rows)) throw new Error('分时成交返回异常')
  const trades = parseTrades(rows)
  return /^us/i.test(symbol) ? trades.map(row => ({ ...row, direction: row.direction === 'B' ? 'B' : 'S' })) : trades
}

export async function refreshWatchlist(rows, market) {
  const selections = rows.map(item => stockSelection({ ...item, market }))
  const codeOf = item => item.market === 'cn' ? item.symbol.slice(-2) + item.symbol.slice(0, -3) : item.code
  const codes = [...new Set(selections.map(codeOf).filter(Boolean))]
  const values = {}
  if (codes.length) Object.assign(values, await getStockQuotes(codes.join(',')))
  return rows.map((item, index) => {
    const value = values[codeOf(selections[index])]
    return Array.isArray(value) && quoteNumber(value[3]) > 0 ? { ...item, last_px: value[3], px_change_rate: quoteNumber(value[32]) == null ? item.px_change_rate : value[32] } : item
  })
}
